<template>
  <q-page padding>
    <h3>Home page</h3>
  </q-page>
</template>

<script>

export default {
  name: 'Home',
  components: {}
}
</script>
